/* eslint-disable eqeqeq */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-undef */
import * as React from "react"
import {
  ParallaxProvider
} from 'react-scroll-parallax'
import './src/styles/main.scss'
import common from './src/js/common/index'
import index from './src/js/index/index'
export const wrapPageElement = ({
  element,
  props
}) => {
  return <ParallaxProvider {...props}>{element}</ParallaxProvider>
}

export const onRouteUpdate = ({
  location
}) => {

  common()

  if (location.pathname.match(/^\//)) {

    index()

    // form
    const _bownow_cs_sid_0553048ddd2cfb7d93ec = document.createElement('script')
    _bownow_cs_sid_0553048ddd2cfb7d93ec.src = 'https://contents.bownow.jp/forms/sid_0553048ddd2cfb7d93ec/trace.js'
    try {
      document.getElementsByTagName('head')[0].appendChild(_bownow_cs_sid_0553048ddd2cfb7d93ec)
    } catch {

    }
  }

  ((d) => {
    var config = {
      kitId: 'zgu5ydl',
      scriptTimeout: 3000,
      async: true
    },
      h = d.documentElement, t = setTimeout(function () { h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive"; }, config.scriptTimeout), tk = d.createElement("script"), f = false, s = d.getElementsByTagName("script")[0], a; h.className += " wf-loading"; tk.src = 'https://use.typekit.net/' + config.kitId + '.js'; tk.async = true; tk.onload = tk.onreadystatechange = function () { a = this.readyState; if (f || a && a != "complete" && a != "loaded") return; f = true; clearTimeout(t); try { Typekit.load(config) } catch (e) { } }; s.parentNode.insertBefore(tk, s)
  })(document)
}
